var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcoqEwec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "i8x67ilvja",
    width: "153.5%",
    height: "153.5%",
    x: "-26.8%",
    y: "-23.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "9svn8kclwb",
    cx: 29.896,
    cy: 29.896,
    r: 29.896
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-810.000000, -790.000000) translate(810.000000, 790.000000) translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#i8x67ilvja)",
    xlinkHref: "#9svn8kclwb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F7F6FB",
    xlinkHref: "#9svn8kclwb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#EE3D85",
    transform: "translate(-810.000000, -790.000000) translate(810.000000, 790.000000) translate(0.500000, 0.000000) translate(30.000000, 30.000000) rotate(-315.000000) translate(-30.000000, -30.000000) translate(16.500000, 16.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 27,
    x: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0h1c.552 0 1 .448 1 1v25c0 .552-.448 1-1 1h-1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1z",
    transform: "translate(13.500000, 13.500000) rotate(-270.000000) translate(-13.500000, -13.500000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcoqEwec);
export default __webpack_public_path__ + "static/media/OCOQEwec.a9ae6e6290cb580366a533d0add5503f.svg";
export { ForwardRef as ReactComponent };